import {useContext} from 'react';
import {getDefaultViewMode} from '../../buildExtractedConfig';
import {ConfigContext} from '../../Providers/ConfigProvider';

export const useDrawerEnabled = () => {
  const config = useContext(ConfigContext);
  const viewMode = getDefaultViewMode({
    entryPoint: config.entrypoint,
    viewMode: config.viewMode,
  });

  return viewMode === 'drawer';
};
